import { http, responseData } from './axios';
import type { LoginPayload, LoginResponse } from '@/types/api.types';

export const authApi = {
  login(payload: LoginPayload) {
    return http.post<LoginResponse>('/auth/login', payload).then(responseData);
  },
  register(payload: {
    name: string;
    email: string;
    password: string;
    profileType: string;
    company?: string;
    title?: string;
    industry?: string;
    description?: string;
    products?: string[];
    services?: string[];
    fundingGoal?: string;
    website?: string;
    pitchDeckUrl?: string;
  }) {
    return http.post<LoginResponse>('/auth/register', payload).then(responseData);
  },
  logout() {
    return http.post('/auth/logout').then(responseData);
  },
  deleteAccount() {
    return http.delete('/auth/account').then(responseData);
  },
  me() {
    return http.get('/auth/me').then(responseData);
  },
  updateProfile(payload: {
    name?: string;
    title?: string;
    company?: string;
    industry?: string;
    description?: string;
    products?: string[];
    services?: string[];
    profileType?: string;
  }) {
    return http.patch('/auth/me', payload).then(responseData);
  },
  uploadProfilePhoto(file: File) {
    const formData = new FormData();
    formData.append('photo', file);
    return http.post('/auth/me/photo', formData).then(responseData);
  },
};
